import { Footer } from "@/components/Footer"
import { Header } from "@/components/Header"
import { Subfooter } from "@/components/Subfooter"
import { Toaster } from "@/components/ui/toaster"
import * as React from "react"
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from "react-router-dom"
import { AppApolloProvider } from "../authentication/AppApolloProvider"
import { AuthProvider } from "../authentication/AuthProvider"
import { ViewerProvider } from "../authentication/ViewerProvider"
import { RequireUserSignedIn } from "./layouts/RequireUserSignedIn"
import { RequireUserSignedOut } from "./layouts/RequireUserSignedOut"
import { OrgAdminsErrorBoundary } from "./org-admins-error-boundary"
import * as paths from "./org-admins-paths"
import { DashboardScreen } from "./screens/dashboard/DashboardScreen"
import { ConfirmEmailScreen } from "./screens/onboarding/confirm-email/ConfirmEmailScreen"
import { CreateAccountScreen } from "./screens/onboarding/create-account/CreateAccountScreen"
import ForgotPasswordScreen from "./screens/onboarding/forgot-password/ForgotPasswordScreen"
import SignInScreen from "./screens/onboarding/SignInScreen"
// import CreateAccountScreen from "./screens/onboarding/CreateAccountScreen";

declare global {
  interface Window {
    novus: {
      googlePlayAppUrl: string
      appleAppUrl: string
      linkedInUrl: string
      maximumContributionAmountCents: string
    }
  }
}

const OrgAdminsLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <Outlet />
      <Subfooter />
      <Footer />
    </div>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path={paths.rootPath.pattern}
      element={<OrgAdminsLayout />}
      errorElement={<OrgAdminsErrorBoundary />}
    >
      <Route element={<RequireUserSignedIn />}>
        {/* Dashboard */}
        <Route index element={<DashboardScreen />} />
      </Route>

      <Route element={<RequireUserSignedOut />}>
        {/* Onboarding */}
        <Route path={paths.signInPath.pattern} element={<SignInScreen />} />
        <Route
          path={paths.forgotPasswordPath.pattern}
          element={<ForgotPasswordScreen />}
        />
        <Route
          path={paths.createAccountPath.pattern}
          element={<CreateAccountScreen />}
        />
        <Route
          path={paths.confirmEmailPath.pattern}
          element={<ConfirmEmailScreen />}
        />
      </Route>
    </Route>,
  ),
)

export const App = () => {
  return (
    <AuthProvider context="org-admin">
      <AppApolloProvider>
        <ViewerProvider>
          <Toaster />
          <RouterProvider router={router} />
        </ViewerProvider>
      </AppApolloProvider>
    </AuthProvider>
  )
}
